import { combineReducers } from "redux";
import {
  createPaginatedList,
  paginationGroup
} from "MODULES/shared/pagination";
import api from "APP_ROOT/api";

const locate = name => state => state.companyPagination[name];

export const companiesPagination = createPaginatedList({
  listId: "companies",
  fetch: api.companies.searchWithAddress,
  stateLocator: locate("main"),
  forceDebounce: true,
  initialSettings: {
    sort: "name"
  }
});

const companiesApi = key => (id, { page, limit }) =>
  api.companies[key].search(id, { page, limit });

const config = key => ({ key, collect: true, api: companiesApi(key) });

const [
  aircrafts,
  contacts,
  physicalAddresses,
  relatedCompanies,
  shippingMethods
] = paginationGroup(
  {
    groupName: "company",
    getId: state => state.companyDetail.getIn(["company", "id"]),
    locate: ({ key }) => locate(key)
  },
  config("aircrafts"),
  config("contacts"),
  config("physicalAddresses"),
  config("relatedCompanies"),
  config("shippingMethods")
);

export default combineReducers({
  main: companiesPagination.paginator,
  aircrafts,
  contacts,
  physicalAddresses,
  relatedCompanies,
  shippingMethods
});



// WEBPACK FOOTER //
// ./app/modules/companies/pagination.js